export default __webpack_public_path__ + "static/media/n.4e783f11.jpg";